import apiClient from './apiClient';

const orderService = {
    fetchOrders: (orderStatus) => apiClient.get('/admin/orders.list',{ params: { order_status:orderStatus }}), // Fetch all partner requests

    // 배송중으로 변경 (택배사코드+운송장번호)
    shippingOrder: (order_item_id, invoice_no, selectedCode) => apiClient.post(`/admin/orders.shipping`, {
        order_item_id: order_item_id,
        invoice_no: invoice_no,
        selectedCode: selectedCode
    }),

    // 배송완료처리
    deliveryComplete: (order_item_id) => apiClient.post(`/admin/delivery/complete`, {
        order_item_id: order_item_id
    }),

    // orderStatus만 변경할때
    changeOrderStatus: (order_item_id, order_status) => apiClient.post(`/admin/orders.update`, {
        order_item_id: order_item_id,
        order_status: order_status
    }),
};

export default orderService;
